"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _DepositConfirmationComponent = _interopRequireDefault(require("./DepositConfirmationComponent"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../common/Modal/Modal"));
var _queryParamsHelper = require("../../helpers/queryParamsHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var DepositStatusModalComponent = /*#__PURE__*/function (_React$Component) {
  function DepositStatusModalComponent() {
    var _this;
    _classCallCheck(this, DepositStatusModalComponent);
    _this = _callSuper(this, DepositStatusModalComponent);
    _this.state = {
      txnState: '',
      title: ''
    };
    return _this;
  }
  _inherits(DepositStatusModalComponent, _React$Component);
  return _createClass(DepositStatusModalComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var txnState = (0, _queryParamsHelper.getQueryParam)('txnState');
      var trustPayRedirect = (0, _queryParamsHelper.getQueryParam)('id') && (0, _queryParamsHelper.getQueryParam)('resourcePath') && (0, _queryParamsHelper.getQueryParam)('resourcePath').includes('payment');
      var title;
      if (trustPayRedirect || txnState === '1') {
        title = 'Deposit pending';
        this.setState(function () {
          return {
            txnState: 1,
            title: title
          };
        });
        this.props.openModal();
      }
      if (txnState === '2') {
        title = 'Deposit succesfull';
        this.setState(function () {
          return {
            txnState: txnState,
            title: title
          };
        });
        this.props.openModal();
      }
      if (txnState === '3') {
        title = 'Deposit error';
        this.setState(function () {
          return {
            txnState: txnState,
            title: title
          };
        });
        this.props.openModal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      var _this$props = this.props,
        _close = _this$props.close,
        isOpen = _this$props.isOpen;
      var _this$state = this.state,
        txnState = _this$state.txnState,
        title = _this$state.title;
      if (txnState) {
        return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
          isOpen: isOpen,
          title: t(title),
          close: function close() {
            return _close();
          }
        }, /*#__PURE__*/_react["default"].createElement(_DepositConfirmationComponent["default"], {
          txnState: txnState
        }));
      } else {
        return null;
      }
    }
  }]);
}(_react["default"].Component);
DepositStatusModalComponent.propTypes = {
  isOpen: _propTypes["default"].bool,
  close: _propTypes["default"].func.isRequired,
  openModal: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _reactI18next.withTranslation)("core")(DepositStatusModalComponent);